"use client";

import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";

import { DataTableViewOptions } from "./data-table-view-options";
// import { useUserFilterActions } from "@/pages/users/ducks/filter/hooks/actions";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;
  // const { updateFilter } = useUserFilterActions();

  // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   updateFilter({ key: "search", value: event.target.value });
  // };

  // const debouncedHandleInputChange = useCallback(
  //   debounce(handleInputChange, 500),
  //   []
  // );
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        {isFiltered && (
          <Button
            variant="ghost_disabled"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Resetar
            <X />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  );
}
